export const MAX_CONTENT_WIDTH = 480;

export function rootFontSize(viewportWidth) {
  return Math.min(Math.max(viewportWidth, 1), MAX_CONTENT_WIDTH) * 16 / 390;
}
